import React from 'react';
import { Backdrop, Modal } from '@material-ui/core';

import { AssuranceIcon } from 'images';
import {
  ModalWrapper,
  StyledImg,
  StyledSmallSectionHeader,
  useStyles,
} from 'components/VideoModal/styles';

export default function TransitionsModal(props: {
  open: boolean;
  handleClose: (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
  title: string;
  children: React.ReactNode;
}) {
  const classes = useStyles();
  const BACK_DROP_TIMOUT = 500;
  return (
    <Modal
      className={classes.modal}
      open={props.open}
      onClose={props.handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: BACK_DROP_TIMOUT,
        classes: { root: classes.Backdrop },
      }}
      data-testid="video-modal"
    >
      <ModalWrapper>
        <StyledSmallSectionHeader>{props.title}</StyledSmallSectionHeader>
        <StyledImg
          alt="close-x"
          onClick={props.handleClose}
          src={AssuranceIcon['whiteX']}
        />
        {props.children}
      </ModalWrapper>
    </Modal>
  );
}
